// extracted by mini-css-extract-plugin
export default {"kanban":"KanbanView_kanban__rgb-G","panels":"KanbanView_panels__JNysl","resizeHandle":"KanbanView_resizeHandle__+hBRe"};